import { ThunkDispatch } from "core-integration/src/store";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { handleLogout } from "../../utils/logout";
import { getIsWebView } from "../../utils/webView";
import Button from "../Button";
import { ControlArrowRight } from "../icons/Arrows";
import { ButtonWrapper } from "./styles";

export const FirebaseEntryLinks = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch<ThunkDispatch>();
  const isWebView = getIsWebView();

  if (isWebView) {
    return null;
  }

  const onLogoutClick = () => {
    handleLogout(dispatch, isWebView);
  };

  return (
    <ButtonWrapper>
      <Button
        width={1}
        onClick={onLogoutClick}
        variant="primary"
        endIcon={<ControlArrowRight />}
      >
        {t("signOut", "Sign out")}
      </Button>
    </ButtonWrapper>
  );
};
